import { render, staticRenderFns } from "./TresForm.vue?vue&type=template&id=abd9e0da&"
import script from "./TresForm.vue?vue&type=script&lang=js&"
export * from "./TresForm.vue?vue&type=script&lang=js&"
import style0 from "./TresForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports